import { MultiSelect } from '@treams/treams-ui';

import * as graphql from 'generated/graphql';

export default function ConfigurationFieldMultiSelect(props: {
	field: graphql.ConnectorConfigFieldMultiSelect;
	change?: Partial<graphql.UpdateConnectorConfigFieldInput>;
	onChange: (input: Partial<graphql.UpdateConnectorConfigFieldInput>) => void;
}) {
	const options =
		props.field.options?.map((option) => ({
			title: option.label,
			value: option.value,
		})) ?? [];
	const selectedOptions = props.change?.selectValues ?? props.field.values;

	return (
		<MultiSelect
			options={options}
			selectedOptions={options.filter(({ value }) => selectedOptions?.includes(value))}
			onChange={(values) => {
				props.onChange({ selectValues: values });
			}}
		/>
	);
}
